export default {
    title: "Katalog",
    noAvailableItems: "Keine bestellbaren Produkte verfügbar."
}